import Registration from '@/helpers/Registration';
import Requests from '@/helpers/Request';
import RADIO, { TV_STATUS } from '@/helpers/RADIO';
import router from '@/router';
import Vue from 'vue';
import store from '..';
import StorageHandler from '@/helpers/StorageHandler';
//import socketLogger from './socket-logger';

function filterLang(elem, lang, status) {
  //console.log("----------------------------------filterLang", elem, lang);
  var langA = [];
  if(elem.tags) langA = elem.tags; else return !status;
  var ret = langA.includes(lang);
  if(ret) {
    return status;
  } else {
    return !status;
  }
}

export default {
  namespaced: true,
  state: () => ({
    isOSDActive: true,
    channels: [
      {
        dvb_type: '',
        url: 'https://media.digmedia.net/website/video/rain_264.mp4?_=1',
        name: 'Loading',
        serviceId: 1,
        buildingId: 2,
        originalNetworkId: 1,
        transportStreamId: 1019,
        gateway_id: '61f8401cd25b9f44df810a2d',
        serviceType: 'radio',
        tags: ['de'],
        epgChannelId: 0,
        position: 1,
        price: '0.00',
        frequency: '',
        frequencyInKhz: '0',
        polarization: 'HORIZONTAL',
        symbolRate: '',
        packages: [],
        id: '61f84136d25b9fb434810a2e',
      },
    ],
    epgLoaded: false,
    epgData: {},
    currentChannelIndex: 0,
    targetChannelIndex: 0,
    epgGuideChannelIndex:-1,
    status: TV_STATUS.CLOSED,
  }),
  mutations: {
    setChannels(state, list = []) {
      state.channels = list;
    },
    setChannel(state, index) {
      RADIO.setChannel(state.channels[index]);
    },
    setChannelIndex(state, index) {
      state.currentChannelIndex = index;
    },
    incTargetIndex(state) {
      state.targetChannelIndex++;
    },
    decTargetIndex(state) {
      state.targetChannelIndex--;
    },
    setTargetIndex(state, index) {
      state.targetChannelIndex = index;
    },
    setTVStatus(state, status) {
      state.status = status;
    },
    setEPGData(state, epgData) {
      for (const item of epgData) {
        Vue.set(state.epgData, item.channel_id, item);
      }
    },
    setEPGLoaded(state, value = true) {
      state.epgLoaded = value;
    },
    setEPGGuideStartChannel(state, startChannel={"index": -1, "id": -1}) {
      console.log("startChannel: ", startChannel);
      console.log("available Radio channels: ", this.getters["radio/getChannels"]);

      // tv channel list has radio programs in it, epg channels not -> find right tv channel index
      const findIndexById = (arr, id) => arr.findIndex(obj => obj.id === id);
      const channelIndex = findIndexById(this.getters["radio/getChannels"], startChannel.id);
      if (channelIndex === -1) {
        console.log("Error: did not found a start radio channel index for channelId: " + startChannel.id + "?");
        return;
      }

      console.log("set radio start channel index from " + startChannel.index + " to " + channelIndex);

      state.epgGuideChannelIndex = channelIndex;
    },
  },
  computed: {
    filteredChannels() {
      return this.channels.filter(item => {
         return item.serviceType === "radio";
      })
    }
  },
  actions: {
    setStatus({ commit }, status) {
      commit('setTVStatus', status);
    },
    async prepare({ state, commit, rootState }) {
      if (!state.epgLoaded) {
        const epgData = await Requests.fetchAllEPGData().catch((err) => {
          console.log('ERR: Could not fetch EPG data: ', err);
          return [];
        });
        commit('setEPGData', epgData);
        commit('setEPGLoaded');
      }
      const response = await Requests.fetchChannelList({
        bid: rootState.buildingId,
      });
      //console.log('RESPONSE prepare', response);

      var radioChannels = response.filter((channel) => {
        if(channel.serviceType == "radio") {
          return channel;
        } else {
          return false;
        }
      });

      var appLang = StorageHandler.get('lang') || 'en';
      if(appLang === 'ch_de' || appLang === 'ch_fr' || appLang === 'ch_it') appLang = appLang.split('_', 2)[1];

      var radioChannelsLang = radioChannels.filter(function(element){
        return filterLang(element, appLang, true);
      }).sort((a, b) => a.position - b.position);

      var radioChannelsRest = radioChannels.filter(function(element){
        return filterLang(element, appLang, false);
      }).sort((a, b) => a.position - b.position);

      commit('setChannels', radioChannelsLang.concat(radioChannelsRest));
      return Promise.resolve();
    },
    async init({ commit, dispatch, rootState, getters }) {
      try {
        const response = await Requests.fetchChannelList({
          bid: rootState.buildingId,
        });
        //console.log('RESPONSE init', response);

        var radioChannels = response.filter((channel) => {
          if(channel.serviceType == "radio") {
            return channel;
          } else {
            return false;
          }
        });

        var appLang = StorageHandler.get('lang') || 'en';
        if(appLang === 'ch_de' || appLang === 'ch_fr' || appLang === 'ch_it') appLang = appLang.split('_', 2)[1];

        var radioChannelsLang = radioChannels.filter(function(element){
          return filterLang(element, appLang, true);
        }).sort((a, b) => a.position - b.position);

        var radioChannelsRest = radioChannels.filter(function(element){
          return filterLang(element, appLang, false);
        }).sort((a, b) => a.position - b.position);

        commit('setChannels', radioChannelsLang.concat(radioChannelsRest));
        dispatch('new');
        return Promise.resolve();
      } catch (err) {
        console.log(err);
        return Promise.reject();
      }
    },
    setChannelNext({ state, commit, getters }) {
      let index = getters.getActiveChannelIndex;
      if (index < getters.getChannelLength - 1) {
        index++;
      } else {
        index = 0;
      }
      RADIO.setChannel(state.channels[index]);
      commit('setChannelIndex', index);
      commit('setTargetIndex', index);
    },
    setChannelPrev({ commit, state, getters }) {
      let index = getters.getActiveChannelIndex;
      if (index > 0) {
        index--;
      } else {
        index = getters.getChannelLength - 1;
      }
      RADIO.setChannel(state.channels[index]);
      commit('setChannelIndex', index);
      commit('setTargetIndex', index);
    },
    setTargetNext({ dispatch, commit, getters }) {
      let index = getters.getTargetChannelIndex;
      if (index < getters.getChannelLength - 1) {
        commit('incTargetIndex');
        index++;
      } else {
        index = 0;
        commit('setTargetIndex', index);
      }
      //setTimeout(() => {
      //  console.log('!!!!INDEX', index);
        //dispatch('setTargetChannel', index);
      //}, 2000);
    },
    setTargetPrev({ dispatch, commit, getters }) {
      let index = getters.getTargetChannelIndex;
      if (index > 0) {
        commit('decTargetIndex');
        index--;
      } else {
        index = getters.getChannelLength - 1;
        commit('setTargetIndex', index);
      }
      //setTimeout(() => {
      //  console.log('!!!INDEX', index);
        //dispatch('setTargetChannel', index);
      //}, 2000);
    },
    setTargetChannel({ commit, getters }, index) {
      console.log('SET TARGET CHANNEL: ', index, getters.getTargetChannelIndex);
      const targetIndex = getters.getTargetChannelIndex;
      if (index !== targetIndex) return;
      //console.log('SET-act=', getters.getActiveChannel);
      //console.log('SET-tar=', getters.getTargetChannelIndex);
      if (targetIndex === getters.getActiveChannelIndex) return;
      commit('setChannelIndex', index);
      RADIO.setChannel(getters.getActiveChannel);
    },
    new({ getters, commit }) {
      console.log('CREATE', getters.getActiveChannel);

      // override default current channel when start from EPGGuide
      const epgGuideChannelIndex = getters.getEpgGuideChannelIndex;
      if (epgGuideChannelIndex !== -1) {
        // todo check if channel index exists
        commit('setChannelIndex', epgGuideChannelIndex);
        commit('setTargetIndex', epgGuideChannelIndex);
        commit('setEPGGuideStartChannel', -1);
      }

      RADIO.createPlayer(getters.getActiveChannel);
    },
    kill({ getters, commit }) {
      commit('setChannelIndex', 0);
      commit('setTargetIndex', 0);
      //console.log("===========kill===========getters.getActiveChannel=>", getters.getActiveChannel);
      RADIO.removePlayer(getters.getActiveChannel);
    },
  },
  getters: {
    getTargetChannelIndex(state) {
      return state.targetChannelIndex;
    },
    getChannels(state, getters, rootState, rootGetters) {
      if (!rootGetters['device/getHasTVPackageAssigned']) {
        return state.channels;
      }
      const packageIdent = rootGetters['device/getTVPackageName'];
      return state.channels.filter((channel) => {
        const packages = channel.packages || [];
        return packages.includes(packageIdent);
      });
    },
    getEpgById: (state) => (id) => {
      return state.epgData[id];
    },
    getChannelLength(_, getters) {
      return getters.getChannels.length;
    },
    getActiveChannelIndex(state) {
      return state.currentChannelIndex;
    },
    getIsFirstChannel(_, getters) {
      if (getters.getTargetChannelIndex === 0) {
        return true;
      }
      return false;
    },
    getIsLastChannel(_, getters) {
      if (getters.getTargetChannelIndex === getters.getChannelLength - 1) {
        return true;
      }
      return false;
    },
    getEpgGuideChannelIndex(state) {
      return state.epgGuideChannelIndex;
    },
    getActiveChannel(_, getters) {
      const channel = getters.getChannels[getters.getActiveChannelIndex];
      if (!channel) return {};
      return channel;
    },
    getActiveChannelName(_, getters) {
      return getters.getActiveChannel.name;
    },
    getShowOSD(state) {
      return state.isOSDActive;
    },
    getChannelHeadline(_, getters) {
      const number = getters.getActiveChannelIndex + 1;
      const channel = getters.getActiveChannelName;
      return `${number} ${channel}`;
    },
    getStatus(state) {
      return state.status;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/radio.js